import React, { Component } from 'react';

import { FormattedHTMLMessage } from 'react-intl';
import { Row, Col, Checkbox } from 'react-bootstrap';

import FullScreenTemplate from './FullScreenTemplate.js';
require(`../css/components/ddjjwarningmodal.css`);

class DDJJWarningModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            checkedTos: false,
            acceptDdjj: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkTos = this.checkTos.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            acceptDdjj: true
        });
    }

    checkTos(event){
        this.setState({
            checkedTos: event.target.checked
        });
    }

    render() {
        const { checkedTos, acceptDdjj } = this.state;

        const modal = (
            <FullScreenTemplate>
                <div className="row">
                        <div className="pd-content-left col-md-5 col-lg-5 text-center">
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                            <FormattedHTMLMessage
                                id="app.intro"
                                defaultMessage="<h6>Financiá tu PyME en Vendimia, es fácil.</h6>"
                                description="Introducción"/>
                        </div>
                        <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                            <div>
                                <form onSubmit={this.handleSubmit} className='pvc-form'>
                                    <Row>
                                    <Col className='text-center' lg={12}>
                                        <FormattedHTMLMessage
                                            id="app.step_start"
                                            description="Start" />
                                        <div className='ddjjwarningmodal-text-container'>
                                            <FormattedHTMLMessage
                                                id="app.step_start_info"
                                                description="Start" />
                                            <FormattedHTMLMessage
                                                id="app.step_ddjj"
                                                description="DDJJ" />
                                        </div>
                                    </Col>
                                    </Row>
                                    <Row className="terms_row">
                                        <Col className=" text-center" xs={12} md={12} lg={12}>
                                            <Checkbox checked={checkedTos} onClick={this.checkTos}>{'Acepto términos y condiciones'}</Checkbox>
                                        </Col>
                                    </Row>
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={!checkedTos}>Aceptar</button>
                                </form>
                            </div>
                        </div>
                </div>
            </FullScreenTemplate>
        );

        return !acceptDdjj ? modal : null;
    }
}

export default DDJJWarningModal;



/** WEBPACK FOOTER **
 ** ./src/components/DDJJWarningModal.js
 **/